import { Injectable } from '@angular/core';
import {
  ActivatedRouteSnapshot,
  CanActivate,
  Router,
  RouterStateSnapshot,
  UrlTree,
} from '@angular/router';
import { getDefaultRouteForRole } from '@app/enumerations/role';
import { AuthService } from '@app/services/auth.service';
import { map, Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class RoleBasedRedirectGuard implements CanActivate {
  constructor(
    private router: Router,
    private authService: AuthService,
  ) {}

  canActivate(
    _next: ActivatedRouteSnapshot,
    _state: RouterStateSnapshot,
  ):
    | Observable<boolean | UrlTree>
    | Promise<boolean | UrlTree>
    | boolean
    | UrlTree {
    return this.authService.ensureSession().pipe(
      map((hasSession) => {
        if (!hasSession) {
          return true;
        }

        const userRole = this.authService.getUserRole();

        if (!userRole) {
          this.authService.logout();
          return this.router.createUrlTree(['/auth']);
        }

        const defaultRoute = getDefaultRouteForRole(userRole);

        return this.router.createUrlTree([defaultRoute]);
      }),
    );
  }
}
